<div id="relatorio-receitas-despesas" class="container p-6">

  <!-- Cabeçalho: Identificação -->
  <div class="container-rede-municipal">
    <h1 class="texto-grayscale-900 text-display-sm text-regular">
      {{ titulo }}
    </h1>

    <div class="container-colunas">
      <div class="flex flex-col gap-2">
        <div  class="flex flex-col">
          <span class="texto-grayscale-900 text-body-lg text-regular">UF</span>
          <span class="texto-grayscale-900 text-body-lg text-bold">{{ uf || '-' }}</span>
        </div>
        <div  class="flex flex-col">
          <span class="texto-grayscale-900 text-body-lg text-regular">Município</span>
          <span class="texto-grayscale-900 text-body-lg text-bold">{{ municipio || '-' }}</span>
        </div>
      </div>

      <div class="flex flex-col gap-2">
        <div  class="flex flex-col">
          <span class="texto-grayscale-900 text-body-lg text-regular">Código IBGE</span>
          <span class="texto-grayscale-900 text-body-lg text-bold">{{ codigoIbge || '-' }}</span>
        </div>
        <div class="flex flex-col">
          <span class="texto-grayscale-900 text-body-lg text-regular">Dependência administrativa</span>
          <span class="texto-grayscale-900 text-body-lg text-bold">{{ dependenciaAdministrativa || '-' }}</span>
        </div>
      </div>

      <div class="flex flex-col gap-2">
        <div  class="flex flex-col">
          <span class="texto-grayscale-900 text-body-lg text-regular">Número de escolas</span>
          <span class="texto-regular texto-grayscale semibold">{{ getTotalEscolas() ? (getTotalEscolas() | number:'1.0-0') : '-' }}</span>
        </div>
        <div class="flex flex-col">
          <span class="texto-grayscale-900 text-body-lg text-regular">Número de matrículas</span>
          <span class="texto-grayscale-900 text-body-lg text-bold">{{ getTotalMatriculas() ? (getTotalMatriculas() | number: '1.0-0') : '-' }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- SEÇÃO 1: RECEITAS REALIZADAS -->
  <ng-container *ngIf="linhasTabelaReceitasRealizadas.length > 0">
    <div class="flex flex-col mt-5 gap-2 mb-1">
      <h1 class="texto-grayscale-900 text-heading-lg text-regular">
        Receitas realizadas (RPEb)
      </h1>
    </div>

    <div class="container-resumo-valores">
      <div class="flex flex-col">
        <span class="texto-ceu semibold text-4xl">
          {{ totalReceitaAnual | currency:'BRL':'symbol':'1.0-0' }}
        </span>
        <span class="text-weight-400 texto-grayscale-800 text-16">
          total em {{anoRealizado}}¹
        </span>
      </div>

      <div class="flex flex-col items-end text-end">
        <span class="texto-pistache-300 semibold text-4xl">
          {{ atualizarReceitaPorAlunoMensal() | currency:'BRL':'symbol':'1.0-0' }}
        </span>
        <span class="text-weight-400 texto-grayscale-800 text-16 max-w-[200px]">
          receita por aluno ao mês em {{anoRealizado}}
        </span>
      </div>
    </div>

    <!-- Grid Receitas Realizadas -->
    <div class="w-full overflow-x-auto bg-white rounded-lg shadow-sm border border-gray-200">
      <table class="tabela-financiamento">
        <thead>
          <tr>
            <th scope="col" class="p-4 px-7 text-start w-1/2">Detalhamento</th>
            <th scope="col" class="p-4 px-7 text-end w-1/4">Valor (R$)</th>
            <th scope="col" class="p-4 px-7 text-end w-1/4">%</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let linha of linhasTabelaReceitasRealizadas; let last = last"
              class="border-bottom hover:bg-gray-50 transition-colors"
              [class.border-none]="last"
              [class.bg-gray-50]="last">
            <td class="p-3 px-7 align-middle">
              <span class="block texto-grayscale-900"
                    [class.text-bold]="linha.isTitulo"
                    [class.pl-8]="linha.nivelRecuo === 1"
                    [class.pl-16]="linha.nivelRecuo === 2">
                {{ linha.descricao }}
              </span>
            </td>
            <td class="p-3 px-7 text-end align-middle">
              <span class="texto-grayscale-900" [class.text-bold]="linha.isTitulo">
                {{ linha.valor | number:'1.0-0' }}
              </span>
            </td>
            <td class="p-3 px-7 align-middle">
              <div class="flex items-center justify-end gap-4" *ngIf="linha.mostrarBarra">
                <div class="barra-progresso-container">
                  <div class="barra-progresso-fill"
                       [style.width.%]="linha.percentual"
                       [class.bg-ceu]="!last"
                       [class.bg-total]="last">
                  </div>
                </div>
                <span class="texto-porcentagem">
                  {{ linha.percentual | number:'1.1-1' }}
                </span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="mt-6 text-12 text-gray-400 leading-relaxed text-justify">
        <sup>(1)</sup>  Receita Potencial mínima Vinculada à Educação' (RPEb) = [RLI x 25% - receitas destinadas ao Fundeb + receitas
      recebidas do Fundeb + complementações da União ao Fundeb + Salário Educação (cota estadual/municipal) + Receitas de Programas do FNDE (PNAE + PNATE + PDDE + PNLD) + Royalties de Petróleo e Gás]. A RLI é a "receita resultante de impostos, compreendida a proveniente de transferências", base de cálculo da vinculação constitucional de recursos para a educação (Art. 212 da CF).
      <br/>
      <p class="mt-4">
        Fonte: <br />
        Elaborado pelo Laboratório de Dados Educacionais a partir dos Relatório Resumido da Execução Orçamentária (RREO) – Tesouro Nacional 2024
        <br />
      </p>
    </div>
  </ng-container>


  <!-- SEÇÃO 2: PROJEÇÃO DE DESPESAS CORRENTES CAQ -->
  <div class="flex flex-col mt-8 gap-2 mb-4" *ngIf="despesasCorrentes">
    <h1 class="texto-grayscale-900 text-heading-lg text-regular">
      Projeção das despesas correntes necessárias CAQ
    </h1>
  </div>

  <div class="container-resumo-valores" *ngIf="despesasCorrentes">
    <div class="flex flex-col">
      <span class="texto-ceu semibold text-4xl">
        {{ despesasCorrentes?.total | currency:'BRL':'symbol':'1.0-0' }}
      </span>
      <span class="text-weight-400 texto-grayscale-800 text-16">
        projeção para {{anoProjecao}}
      </span>
    </div>

    <div class="flex flex-col items-end text-end">
      <span class="texto-pistache-300 semibold text-4xl">
        {{ caqPorAlunoMensal | currency:'BRL':'symbol':'1.0-0' }}
      </span>
      <span class="text-weight-400 texto-grayscale-800 text-16 max-w-[200px]">
        CAQ ao mês em {{anoProjecao}}
      </span>
    </div>
  </div>

  <!-- Grid Despesas Correntes -->
  <div class="w-full overflow-x-auto bg-white rounded-lg shadow-sm border border-gray-200 mb-2" *ngIf="linhasTabelaDespesasCorrentes.length > 0">
    <table class="tabela-financiamento">
      <thead>
        <tr>
          <th scope="col" class="p-4 px-7 text-start w-1/2">Detalhamento</th>
          <th scope="col" class="p-4 px-7 text-end w-1/4">Valor (R$)</th>
          <th scope="col" class="p-4 px-7 text-end w-1/4">%</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let linha of linhasTabelaDespesasCorrentes; let last = last"
            class="border-bottom hover:bg-gray-50 transition-colors"
            [class.border-none]="last"
            [class.bg-gray-50]="last">
          <td class="p-3 px-7 align-middle">
            <span class="block texto-grayscale-900"
                  [class.text-bold]="linha.isTitulo"
                  [class.pl-8]="linha.nivelRecuo === 1">
              {{ linha.descricao }}
            </span>
          </td>
          <td class="p-3 px-7 text-end align-middle">
            <span class="texto-grayscale-900" [class.text-bold]="linha.isTitulo">
              {{ linha.valor | number:'1.0-0' }}
            </span>
          </td>
          <td class="p-3 px-7 align-middle">
            <div class="flex items-center justify-end gap-4">
              <div class="barra-progresso-container">
                <div class="barra-progresso-fill"
                     [style.width.%]="linha.percentual"
                     [class.bg-ceu]="!last"
                     [class.bg-total]="last">
                </div>
              </div>
              <span class="texto-porcentagem">
                {{ linha.percentual | number:'1.1-1' }}
              </span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="mt-6 text-12 text-gray-400 leading-relaxed text-justify" *ngIf="linhasTabelaDespesasCorrentes.length > 0">
      Fonte: Elaborado por Laboratório de Dados Educacionais com base nos microdados do Censo Escolar/Inep 2024
  </div>

  <!-- SEÇÃO: COMPLEMENTAÇÃO NECESSÁRIA CAQ (2025) -->
   <div *ngIf="despesasCorrentes && linhasTabelaReceitasRealizadas.length > 0">
    <div class="flex flex-col mt-8 gap-2 mb-4">
    <h1 class="texto-grayscale-900 text-heading-lg text-regular">
      Complementação necessária CAQ ({{anoProjecao}})
    </h1>
    </div>
    <div class="flex flex-row mt-5 items-center gap-complementacao">
    <div class="flex flex-col">
      <span class="texto-ceu semibold text-4xl">
        {{ complementacaoNecessaria | currency:'BRL':'symbol':'1.0-0' }}
      </span>
      <span class="text-weight-400 texto-grayscale-800 text-16">
        projeção para {{anoProjecao}}
      </span>
    </div>

      <div class="container-numero-docentes flex flex-col">
        <div class="porcentagem flex flex-col" [ngStyle]="{
        'width': larguraQuantidadeReceitaLiquida + 'px',
        }">
          <div class="flex flex-col">
            <label class="titulo-quantidade-existente texto-cenoura text-weight-400">
              {{totalReceitaAnual | number:'1.0-0'}}
            </label>

            <div class="div-existente div-existente-numero-docentes relative">
              <div class="container-quantidade-necessarias flex flex-col items-end" [ngStyle]="{
            'width': larguraQuantidadeDespesasNecessarias + 'px',
          }">
                <label class="titulo-necessaria texto-imperial text-weight-400">{{despesasCorrentes?.total |
                  number:'1.0-0'}}</label>
                <div class="div-necessarias div-necessarias-numero-docentes absolute">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-row mt-6 justify-center gap-8">
          <div class="legenda-existente-docentes flex flex-row gap-1">
            <span style="margin-top: -2px; color: rgba(255, 148, 57, 1); width: 10px;height: 10px;">●</span>
            <span class="texto text-weight-400 texto-grayscale text-16">receita líquida (RPEB)</span>
          </div>
          <div class="legenda-necessarias-docentes flex flex-row gap-1">
            <span style="margin-top: -2px; color: #FEBE0D; width: 10px;height: 10px;">●</span>
            <span class="texto text-weight-400 texto-grayscale text-16">despesa corrente necessária</span>
          </div>
        </div>
        <div class="legenda-numero-docentes p-2">
          <div class="flex flex-col">
            <div class="flex flex-row gap-1">
              <span style="margin-top: -2px; color: rgba(255, 148, 57, 1); width: 10px;height: 8px;">●</span>
              <span class="text-weight-400 text-16" style="color: white;font-size: 13px;">receita líquida (RPEB)
                {{totalReceitaAnual | number:'1.0-0'}}</span>
            </div>
            <div class="flex flex-row gap-1">
              <span style="margin-top: -2px; color: #FEBE0D; width: 10px;height: 8px;">●</span>
              <span class="text-weight-400 text-16" style="color: white;font-size: 13px;">despesa corrente necessária
                {{despesasCorrentes?.total | number:'1.0-0'}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
    <div class="mt-6 text-12 text-gray-400 leading-relaxed text-justify" *ngIf="despesasCorrentes && linhasTabelaReceitasRealizadas.length > 0">
      Fonte: Elaborado por Laboratório de Dados Educacionais com base nos microdados do Censo Escolar/Inep 2024
    </div>

  <!-- SEÇÃO: PROJEÇÃO DA DESPESA DE CAPITAL NECESSÁRIA -->
  <ng-container *ngIf="linhasTabelaDespesasCapital.length > 0">
    <div class="flex flex-col mt-8 gap-2 mb-4">
      <h1 class="texto-grayscale-900 text-heading-lg text-regular">
        Projeção da despesa de capital necessária
      </h1>
    </div>

    <div class="container-resumo-valores">
      <div class="flex flex-col">
        <span class="texto-ceu semibold text-4xl">
          {{ totalDespesaCapital | currency:'BRL':'symbol':'1.0-0' }}
        </span>
        <span class="text-weight-400 texto-grayscale-800 text-16">
          projeção para {{anoProjecao}}
        </span>
      </div>
    </div>

    <!-- Grid Despesas Capital -->
    <div class="w-full overflow-x-auto bg-white rounded-lg shadow-sm border border-gray-200 mb-05">
      <table class="tabela-financiamento">
        <thead>
          <tr>
            <th scope="col" class="p-4 px-7 text-start w-1/2">Detalhamento</th>
            <th scope="col" class="p-4 px-7 text-end w-1/4">Valor (R$)</th>
            <th scope="col" class="p-4 px-7 text-end w-1/4">%</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let linha of linhasTabelaDespesasCapital; let last = last"
              class="border-bottom hover:bg-gray-50 transition-colors"
              [class.border-none]="last"
              [class.bg-gray-50]="last">
            <td class="p-3 px-7 align-middle">
              <span class="block texto-grayscale-900"
                    [class.text-bold]="linha.isTitulo"
                    [class.pl-8]="linha.nivelRecuo === 1">
                {{ linha.descricao }}
              </span>
            </td>
            <td class="p-3 px-7 text-end align-middle">
              <span class="texto-grayscale-900" [class.text-bold]="linha.isTitulo">
                {{ linha.valor | number:'1.0-0' }}
              </span>
            </td>
            <td class="p-3 px-7 align-middle">
              <div class="flex items-center justify-end gap-4">
                <div class="barra-progresso-container">
                  <div class="barra-progresso-fill"
                       [style.width.%]="linha.percentual"
                       [class.bg-ceu]="!last"
                       [class.bg-total]="last">
                  </div>
                </div>
                <span class="texto-porcentagem">
                  {{ linha.percentual | number:'1.1-1' }}
                </span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

      <div class="mt-6 text-12 text-gray-400 leading-relaxed text-justify">
        Fonte: Elaborado por Laboratório de Dados Educacionais com base nos microdados do Censo Escolar/Inep 2024
      </div>
  </ng-container>

  <!-- SEÇÃO: DESPESA LÍQUIDA REALIZADA -->
  <ng-container *ngIf="dadoDespesaRealizada">
    <div class="flex flex-col mt-8 gap-2 mb-4">
      <h1 class="texto-grayscale-900 text-heading-lg text-regular">
        Despesa líquida realizada
      </h1>
    </div>

    <div class="container-resumo-valores">
      <div class="flex flex-col">
        <span class="texto-pistache-300 semibold text-4xl">
          {{ totalDespesaRealizada | currency:'BRL':'symbol':'1.0-0' }}
        </span>
        <span class="text-weight-400 texto-grayscale-800 text-16">
          total em {{anoRealizado}}
        </span>
      </div>
    </div>
    <div class="text-12 text-gray-400 leading-relaxed text-justify">
      <p>
        Fonte: Elaborado pelo Laboratório de Dados Educacionais a partir dos Relatório Resumido da Execução Orçamentária (RREO) – Tesouro Nacional 2024
      </p>
    </div>
  </ng-container>
</div>
